import styled, { keyframes, css } from 'styled-components';


export const themes = {
    common: {
        fontFamily:
            "'Open Sans' 'Raleway'",
        breakpoints: {
            xs: "600px",
            sm: "768px",
            md: "992px",
            lg: "1200px",
            xl: "1900px"
        },
    },

    light: {
        type: 'light',
        bgColor: 'white',
        color: '#3E4C59',
        searchBgColor: '#E4E7EB',
        boxShadow: '0.8rem 0.8rem 1.5rem gray',
        categoryColor: '#999',
        categoryHoverColor: '#333',
    },
    dark: {
        type: 'dark',
        bgColor: '#1F2933',
        color: '#E4E7EB',
        searchBgColor: '#E4E7EB',
        boxShadow: '0.4rem 0.4rem 1.5rem #111111',
        categoryColor: '#CBD2D9',
        categoryHoverColor: '#9AA5B1',
    },
}

export const opacity = keyframes`
    from{opacity:0}
    to{opacity:1}
`

export const Body = styled.div<any>`
    background:#F5F5F5;
    padding: ${props => props.padding ? props.padding : '50px'};
    animation: ${opacity} 3s ease;

    //layout
    flex: 1 1 auto;
    @media (max-width: ${props => props.theme.breakpoints.md}){
        margin: 0px;
        padding: 0px;
        width: 100%;
    }
  
    @media print {
        background: transparent;
    }
`

type SpinnerReady = {
    ready: boolean
}

export const curtain = keyframes`
    0% { top:0} 
    100% {top:-100% }
`

export const HomeLoaderContainer = styled.div<SpinnerReady>`

    width: 100%;
    height: 100%;
    z-index:100;
    background:#ffffff;
    position:absolute;
    ${props => props.ready && css`
        animation: ${curtain} 3.0s forwards;
    `}
    align-items: center;
    display: flex;
    justify-content: center;
`

export const PageContainer = styled.div`
display: flex;
flex-flow: column;
height: 100vh;
`

export const Container = styled.div`
    padding: 40px 0;
    background: #ffffff;
    margin: 0px 100px;
    border-radius: 4px;
    box-shadow:
        0 2.8px 2.2px rgba(0, 0, 0, 0.034),
        0 6.7px 5.3px rgba(0, 0, 0, 0.048),
        0 12.5px 10px rgba(0, 0, 0, 0.06),
        0 22.3px 17.9px rgba(0, 0, 0, 0.072),
        0 41.8px 33.4px rgba(0, 0, 0, 0.086),
        0 100px 80px rgba(0, 0, 0, 0.12) ;
    flex: 1 1 auto; 
     @media (max-width: ${props => props.theme.breakpoints.md}){
        margin: 0px;
        background: transparent;         
        box-shadow:none;
    } 
`

export const WhiteContainer = styled(Container)`
    padding: 0em;
    @media (max-width: ${props => props.theme.breakpoints.md}){
        margin: 2em 0em 4em 0em;
        background: white;         
        box-shadow:0 2.8px 2.2px rgba(0,0,0,0.034);
    } 

    @media print {
        background: transparent;         
        box-shadow: 0;
    }
`

type TypeTitle = {
    text?: string
    color?: string
}


export const Title = styled.div<TypeTitle> `
    font-size: 40px;
    font-family: 'Raleway';
    cursor: pointer;    
    color : #222222;
    margin-left:20px;
    border-bottom: solid 1px #F6F6F6;
    &:hover{
        color:  ${props => props.color};
    }
    &:after{
        content:""; 
        width: 200px;
        background-color: ${props => props.color};
        height: 2px;
        display: block;
        }
    @media (max-width: ${props => props.theme.breakpoints.md}){
        font-size: 20px;
        border-bottom: solid 1px rgba(246, 246, 246, 1);
        &:after{ 
            width: 70px;
        }
        
    } 
    @media (max-width: ${props => props.theme.breakpoints.xs}){
        margin-top:40px;
    } 
`
interface LastImage {
    lastImage?: boolean;
}
export const ContainerCard = styled.div<LastImage>`
    justify-content:center;
    margin: 40px 20px;
    display: flex;
    overflow-x: scroll;
    overflow-y: hidden;
    -ms-overflow-style: none;  
    scrollbar-width: none;
    &::-webkit-scrollbar{
        display: none;
    }
    @media (max-width: ${props => props.theme.breakpoints.md}){
        justify-content: center;
        align-items: center;        
    }
    @media (max-width: ${props => props.theme.breakpoints.xs}){
        justify-content:${props => props.lastImage ? "center" : "flex-start"};
        height:300px; 
        margin: 0;
        margin-left:20px;
    }
`
interface CardProps {
    discount?: number | null;
    secondImage?: string
    src?: string | null
    bgColor?: string,
    showInGrid?: boolean;
}

export const CardImg = styled.div<CardProps>`
width: 100%;
max-width: 320px;
height: 320px;
max-height: 320px;
border-radius:10px;
background-size: 100% 100%;
background-image:url(${props => props.src});

@media (max-width: ${props => props.theme.breakpoints.xs}){
    ${props => props.showInGrid? css`
        width: 50vw;
        height: 50vw;
        max-width: 100%;
    ` : css`
        width: 220px;
        height: 200px;
        border-bottom-left-radius:0;
        border-bottom-right-radius:0;
        `
    }
}; 
`
export const Card = styled.div<CardProps>`
    position:relative;
    text-align: center;
    overflow:hidden;
    width: 320px;
    height: auto;
    cursor: pointer;
    border-radius:10px;
    display: inline-block;
    vertical-align: top;
    &:hover ${CardImg}{
        background-image :url( ${props => props.secondImage});
        }
    @media (max-width: ${props => props.theme.breakpoints.md}){
            justify-content: center;
            flex-direction: column;
            align-items: center;
        }

    @media (max-width: ${props => props.theme.breakpoints.xs}){
        width: 220px;
        background-color:${props => props.bgColor};
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
`
export const BodyCard = styled.div`
    padding: 2px 16px;
`
export const ProductName = styled.div<TypeTitle> `
    color: #999999 ;
    font-size: 20px;
    &:after{
        content:${(props) => `"${props.text}"`};
        @media (max-width: ${props => props.theme.breakpoints.xs}){
            font-size: .9rem;
        }
    }

  
`
type TypeRegularPrice = {
    regularPrice?: number
}
export const RegularPrice = styled.span<TypeRegularPrice> `
        color: #999999 ;
        font-size: 14px;
        text-decoration:line-through;
    
    `


export const Price = styled.div<TypeTitle>`
    font-weight: bold;
    font-size: 22px;
    @media (max-width: ${props => props.theme.breakpoints.md}){
        font-size: 1.2rem;
    } 
`
export const PriceSecond = styled.div`
    font-weight: bold;
    font-size: 22px;
    margin-top:17px;
    
`
export const NavBottom = styled.div`
    display:none;
    @media (max-width: ${props => props.theme.breakpoints.md}){
        background-color: #ffffff;
        position:relative;
        z-index:100000000;
        overflow: hidden;
        position: fixed;
        display: flex;
        bottom: 0;
        width: 100vw; 
        height:50px;
        box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.1);
        justify-content: space-evenly;
        align-items: center;
        & > a{
                float: left;
                display: block;
                color: #333333;
                text-align: center;
                padding: 14px 16px;
                text-decoration: none;
                font-size: 17px;
        }
    } 
     @media print {
        display: none;
    }
   
`

type TypeWpp = {
    open: boolean;
    show?: boolean,
    bottom?: string,
}

export const WhatsappContainer = styled.div<TypeWpp> `
    position: fixed;
    width:55px;
    height:55px;
    border-radius: ${props => props.open ? '50% 0 50% 50%' : '50% 50% 0 50%'};
    background: #25D366;
    box-shadow: 0px 3px 4px rgba(153, 153, 153, 0.25);
    display: ${props => props.show ? 'flex' : 'none'};
    align-items: center;
    justify-content: center;
    svg{
            width: 30px;
            height: 30px;
            margin-left: 3px;
        }
    @media (max-width: ${props => props.theme.breakpoints.md}){
        right: 0;
        bottom: ${props => props.bottom ?? '4rem'};
        width: 42px;
        height: 42px;
        svg{
            margin-left: 3px;
            width: 20px;
            height: 20px;
        }
    } 
    @media print {
        display: none;
        visibility: hidden;
    }
    
`

export const FromComponent = styled.span<any>`
    font-weight: ${props => props.fontWeight ?? '400'};
    font-size: ${props => props.fontSize ?? '22px'};
    font-family: 'Raleway';
`

export const fontTitle = "Raleway";
export const fontPrices = "Open Sans";

export const breakPoints = {

    xs: Number(themes.common.breakpoints.xs.replace(/px$/, '')),
    sm: Number(themes.common.breakpoints.sm.replace(/px$/, '')),
    md: Number(themes.common.breakpoints.md.replace(/px$/, '')),
    lg: Number(themes.common.breakpoints.lg.replace(/px$/, '')),
    xl: Number(themes.common.breakpoints.xl.replace(/px$/, '')),

}